import WebAppointmentListModelBase from '../_generated/modelBases/web-appointment-list-model-base';

export default class WebAppointmentListModel extends WebAppointmentListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
